import { getBalance } from './getBalance.js';
import { getTransactionFee } from './getTransactionFee.js';
import { getTransactions } from './getTransactions.js';
export const ankrMethods = {
    getBalance,
    getTransactions,
    getTransactionFee,
};
//# sourceMappingURL=methods.js.map